import puppyPackAPI from "@/app/apis/main/puppy-pack/puppy-pack-api.js";

export default {
    /**
     * @return {object} product list
     * @param {*} puppyPackDetails - Contains pagination data
     * @param productId
     */
    async getPuppyPacks(puppyPackDetails) {
        return puppyPackAPI.getPuppyPacks(puppyPackDetails);
    },

    /**
     * Get details of a specific puppy pack.
     *
     * @param {string} puppyPackId - The unique identifier of the puppy pack.
     * @returns {Promise<object>} A promise that resolves to an object representing the puppy pack details.
     */
    async getPuppyPackDetails(puppyPackId) {
        return puppyPackAPI.getPuppyPackDetails(puppyPackId);
    },

};
